import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  loginRequest,
  ssoLoginRequest,
  fetchLoginHelperText,
  validateMfaRequest,
  fetchMfaStatus,
} from '../../actions';
import Login from './Login';
import Verify from './Verify';

class LoginContainer extends Component {
  constructor(props) {

    super(props);

    this.state = {
      username: '',
      errorUsername: '',
      password: '',
      errorPassword: '',
      mfacode: '',
      errorMFA: '',
      error: '',
      rememberMe: false
    };
  }

  componentDidMount() {

    this.props.fetchLoginHelperText();
    this.props.fetchMfaStatus();
  }

  handleSubmitLogin = e => {
    e.preventDefault();

    const username = this.state.username.trim();
    const password = this.state.password.trim();

    if (!username || !password) {
      if (!username) {
        this.setState({ errorUsername: 'Username required' });
      } else {
        this.setState({ errorUsername: '' });
      }

      if (!password) {
        this.setState({ errorPassword: 'Password required' });
      } else {
        this.setState({ errorPassword: '' });
      }
    } else {
      this.props.loginRequest({
        username,
        password,
      });
    }
  };

  handleSubmitMFA = e => {
    e.preventDefault();

    const username = this.state.username.trim();
    const password = this.state.password.trim();
    const mfacode = this.state.mfacode.trim();
    const rememberMe = this.state.rememberMe;

    if (!mfacode) {
      this.setState({ errorMFA: 'Verification Code required' });
    } else {
      this.setState({ errorMFA: '' });
      this.props.validateMfaRequest({ username, password, mfacode, rememberMe });
    }
  };

  handleUsernameChange = e => {
    this.setState({ username: e.target.value });

    if (this.state.errorUsername) {
      this.setState({ errorUsername: '' });
    }
  };

  handlePasswordChange = e => {
    this.setState({ password: e.target.value });

    if (this.state.errorPassword) {
      this.setState({ errorPassword: '' });
    }
  };

  handleMfaCodeChange = e => {
    this.setState({ mfacode: e.target.value });
  };

  handleCheckBoxChangedEvent = e => {
    this.setState({ rememberMe: e.target.checked });
  };

  renderContactText = () => {
    if (this.props.helperText) {
      return <p className="helper-text mb-0">{this.props.helperText}</p>;
    } else {
      return null;
    }
  };

  renderLogo = () => {
    const url = `/Home/GetLogo`;

    return <img src={url} height="40" alt="logo"/>;
  };



  render() {
    const {
      error,
      success,
      currentlySending,
      loading,
      helperText,
      mfaChallenge,
      mfaText,
    } = this.props;



    if (mfaChallenge) {
      return (
        <Verify
          error={error}
          currentlySending={currentlySending}
          loading={loading}
          handleSubmit={this.handleSubmitMFA}
          handleResend={this.handleSubmitLogin}
          handleMfaCodeChange={this.handleMfaCodeChange}
          mfacode={this.state.mfacode}
          errorMFA={this.state.errorMFA}
          contactText={this.renderContactText}
          logo={this.renderLogo}
          mfaText={mfaText}
          handleCheckBoxChangedEvent={this.handleCheckBoxChangedEvent}
          rememberMe={this.state.rememberMe}
          shouldDisplay={this.props.shouldDisplay}
        />
      );
    } else {
      return (
        <Login
          error={error}
          success={success}
          currentlySending={currentlySending}
          loading={loading}
          helperText={helperText}
          handleSubmit={this.handleSubmitLogin}
          handleUsernameChange={this.handleUsernameChange}
          handlePasswordChange={this.handlePasswordChange}
          ssoLoginRequest={this.props.ssoLoginRequest}
          username={this.state.username}
          errorUsername={this.state.errorUsername}
          password={this.state.password}
          errorPassword={this.state.errorPassword}
          contactText={this.renderContactText}
          logo={this.renderLogo}
          history={this.props.history}
        />
      );
    }
  }
}

const mapStateToProps = state => ({
  error: state.requests.error,
  success: state.requests.success,
  currentlySending: state.requests.currentlySending,
  loading: state.requests.loading,
  helperText: state.loginHelpText,
  mfaChallenge: state.mfa.challenge,
  mfaText: state.mfa.text,
  mfaStatus: state.mfa.status,
  shouldDisplay: state.mfa.shouldDisplay
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loginRequest,
      ssoLoginRequest,
      validateMfaRequest,
      fetchLoginHelperText,
      fetchMfaStatus,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
